import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './_LanguageSwitcher';

const HeaderMenu = ({ children, handleHideMenu = () => { } }) => {

  return (
    <>
      {/*<div id="menu_overlay" onClick={handleHideMenu}/>*/}
      <div id="menu">
        <nav>
          <div>
            <a href={"#0"} id={"menu_close"} onClick={handleHideMenu} />
            {
              React.Children.map(children, (child) => {
                if (typeof child.type !== 'object') {
                  return child;
                }
                return React.cloneElement(child, { onClick: handleHideMenu })
              })
            }
          </div>
        </nav>
      </div>
    </>
  )
}

const Header = () => {

  const { t } = useTranslation();

  const [showMenu, setShowMenu] = useState(false)
  const handleShowMenu = () => setShowMenu(true)
  const handleHideMenu = () => setShowMenu(false)

  useEffect(() => {
    if (showMenu) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  }, [showMenu])

  return (
    <header id="header" isopen={showMenu ? "1" : "0"}>
      <div id="header_wrapper">

        <div className="header_body">

          <div id="burger" onClick={() => setShowMenu(!showMenu)}>
            <div />
            <div />
            <div />
          </div>

          <Link className={"logo_wrapper"} to={"/"} />

          <HeaderMenu handleHideMenu={handleHideMenu}>
            <Link to="/">{t("header_accueil")}</Link>
            <Link to="/#comment-ca-marche" smooth>{t("header_comment_ca_marche")}</Link>
            <Link to="/mes-cartes">{t("header_mon_espace_collection")}</Link>
            <Link to="/les-cadeaux">{t("header_les_cadeaux")}</Link>
            <Link to={"/contact"} className={"grey"}>{t("header_contact")}</Link>
            <Link to={"/faq"} className={"grey"}>{t("header_faq")}</Link>
            <LanguageSwitcher className="d-lg-none" />
            </HeaderMenu>

          <Link className={"connection_cta"} to={"/mon-compte"}>{t("header_mon_compte")}</Link>
          <LanguageSwitcher className="d-none d-lg-inline-block" />
        </div>
      </div>
    </header>
  )
}

export default Header;

